module.exports = __webpack_public_path__ + "static/assets/c39b0a7de5765ba2656e3ba1be958abe.png";